module.exports = __webpack_public_path__ + "img/2-2.6c1fe49a.jpg";